import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueCookies from "vue-cookies";
import Meta from "vue-meta";
import { Constantes } from "../public/Constantes.js";
import VueGtag from "vue-gtag";

import { MEDIA_URL, imgFallback } from "./directives/media.js";
import { initTheme } from "./directives/theme.js";
import { iniciarAvisos } from "./directives/avisosPush.js";
import { GA_ID, RUTAS_EXCLUIDAS, analiticaActiva, plantillaPagina, trackDirective, iniciarSeguimiento } from "./directives/analitica.js";

// Base de las imágenes (/img/gallery y /img/minGallery) y respaldo si falta una miniatura
Vue.prototype.$media = MEDIA_URL;
Vue.directive("img-fallback", imgFallback);

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCookies);
Vue.use(Meta);

Vue.config.productionTip = false;

// Modo claro/oscuro: el elegido por el visitante o, si no ha elegido, el del dispositivo
initTheme(store);

// Eventos de interacción: v-track:nombre_evento="{ … }" (ver directives/analitica.js)
Vue.directive("track", trackDirective);

// Google Analytics 4: solo en la web real (el modo "preview" lo desactiva con VUE_APP_ANALYTICS=off).
// El consentimiento de cookies se fija antes, en public/index.html (Consent Mode v2).
if (analiticaActiva) {
  Vue.use(
    VueGtag,
    {
      config: { id: GA_ID },
      appName: "SantoDomingoCartagena",
      // Una visita a página en cada cambio de ruta, con título legible y URL completa
      // (incluye ?id= de la noticia o del álbum)
      pageTrackerEnabled: true,
      pageTrackerUseFullPath: true,
      pageTrackerTemplate: plantillaPagina,
      // El panel de administración no se mide
      pageTrackerExcludedRoutes: RUTAS_EXCLUIDAS,
    },
    router
  );
}

// Clics, scroll, navegación entre páginas y texto copiado (desde la primera visita)
iniciarSeguimiento(router);

// Service worker de los avisos al móvil (public/sw.js)
iniciarAvisos();

new Vue({
  router,
  store,
  data: {
    constantes: Constantes,
  },
  render: (h) => h(App),
}).$mount("#app");
